import { forwardRef, type HTMLProps, type Ref } from 'react'

import classNames from 'classnames'

import classes from './PipelineTable.module.scss'

export interface Props extends HTMLProps<HTMLTableElement> {
  ref?: Ref<HTMLTableElement>
}

export const PipelineTable = forwardRef<HTMLTableElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <table
        {...props}
        ref={ref}
        className={classNames(classes.PipelineTable, className)}
      />
    )
  }
)

PipelineTable.displayName = 'PipelineTable'
